const convertFilter = providers => {
  const uniqueProviders = [];
  const uniqueProviderIds = new Set();

  providers
    .filter(p => !p.disabled)
    .forEach(p => {
      const providerId = (p.apiValue ?? p.value).toString().toLowerCase();
      if (uniqueProviderIds.has(providerId)) return;
      uniqueProviderIds.add(providerId);
      uniqueProviders.push(p);
    });

  return uniqueProviders.map((p, idx) => ({ provider: p.apiValue ?? p.value, position: idx + 1, is_active: p.isActive }));
};

export default convertFilter;
